import React from 'react'
import { useIntl } from 'react-intl'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import Sheet from 'components/utils/Sheet'
import LoyaltyTierPill from 'loyalty/components/LoyaltyTierPill'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import styled from 'styled-components'

const TriplePointSheet = styled(Sheet)`
 &.bronze {
    background: linear-gradient(63deg, ${props => props.theme.palette.product.loyalty.bronze.lightBackground} 50%, ${props => props.theme.palette.product.loyalty.bronze.normalBackground} 83.34%);
  }

  &.silver {
    background: linear-gradient(63deg, ${props => props.theme.palette.product.loyalty.silver.lightBackground} 50%, ${props => props.theme.palette.product.loyalty.silver.normalBackground} 83.34%);
  }

  &.gold {
    background: linear-gradient(63deg, ${props => props.theme.palette.product.loyalty.gold.lightBackground} 50%, ${props => props.theme.palette.product.loyalty.gold.normalBackground} 83.34%);
  }

  &.platinum {
    background: linear-gradient(63deg, ${props => props.theme.palette.product.loyalty.platinum.lightBackground} 50%, ${props => props.theme.palette.product.loyalty.platinum.normalBackground} 83.34%);
  }
`

function TriplePointTakeoverSearchTileBanner() {
  const [tier] = useCurrentLoyaltyTier()
  const intl = useIntl()
  return <TriplePointSheet
    background={`tier-${tier}-primary`}
    className={tier}
    padding={8}
    tabletPadding="12 16"
  >
    <Group direction="horizontal" gap={16} verticalAlign="center">
      <LoyaltyTierPill tier={tier} kind="primary">
        {intl.formatMessage({
          id: 'H8LgZ-qRKJZ7AwSbqZAq',
          defaultMessage: 'Triple points',
          description: 'Loyalty tier pill label for triple points search tile banner',
        })}
      </LoyaltyTierPill>
      <BodyText variant="medium" weight="bold">
        {intl.formatMessage({
          id: 'a17zjk5rRgNf7R0nGv2m',
          defaultMessage: 'Limited-time offer on select packages',
          description: 'Search tile banner text for triple points limited-time offer',
        })}
      </BodyText>
    </Group>
  </TriplePointSheet>
}

export default TriplePointTakeoverSearchTileBanner
